<template>
  <div
    class="editkuang"
    ref="editkuang"
    :style="{ height: height, minHeight: height }"
  >
    <upload-img
      :id="'quill-uploadimg' + i"
      :imgArr="imgArr"
      :imgNumber="imgNumber"
      :fixedNumber="fixedNumber"
      :fixed="fixed"
      :autoCrop="autoCrop"
      :imgHeight="325"
      :imgWidth="520"
      imgInputWidth="0px"
      @delPic="delPic"
      @saveImg="saveImg"
      :nocaijian="isnocaijian"
      :isActive="isActive"
      :isEditorBox="isEditorBox"
      :width100="width100"
      showSetBtn
    />
    <upload-video
      :id="'quill-uploadvideo' + i"
      :imgArr="imgArr"
      :imgNumber="imgNumber"
      :fixedNumber="fixedNumber"
      imgInputWidth="0px"
      @delPic="delPic"
      @saveImg="saveImg"
      :nocaijian="isnocaijian"
      :isActive="isActive"
      :isEditorBox="isEditorBox"
      :width100="width100"
    />
    <upload-pdf
      :id="'quill-uploadpdf' + i"
      :imgArr="imgArr"
      :imgNumber="imgNumber"
      :fixedNumber="fixedNumber"
      imgInputWidth="0px"
      @delPic="delPic"
      @saveImg="saveImg"
      :nocaijian="isnocaijian"
      :isActive="isActive"
      :isEditorBox="isEditorBox"
      :width100="width100"
    />
    <quill-editor
      v-model="contentText"
      :ref="'myQuillEditor' + i"
      class="edit ql-editor"
      @ready="onEditorReady($event)"
      :options="editorOption"
    ></quill-editor>
    <div class="footer" @click="footerClick" v-if="showFooter">
      <span
        class="iconfont icon-gengduo"
        :class="{ 'icon-show-all': isShowAll }"
      ></span>
      <span>{{ isShowAll ? "收起内容" : "展开内容" }}</span>
    </div>
    <div ref="edittitle" class="editbox">
      <slot></slot>
      <div class="blank_left"></div>
    </div>
  </div>
</template>

<script>
import uploadImg from "./uploadImg.vue";
import uploadVideo from "./uploadVideo.vue";
import uploadPdf from "./uploadPdf.vue";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
let toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
  ["link"],
  ["image" ],
  ["video"],
  ["upload"]
];
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    nocaijian: {
      type: Boolean,
      default: false,
    },
    showImg: {
      type: Boolean,
      default: true,
    },
    height: {
      default: "100%",
      type: String,
    },
    showFooter: {
      default: true,
      type: Boolean,
    },
    contentHight: {
      default: 500,
      type: Number,
    },
    i: {
      default: 500,
      type: Number,
    },
    index: {
      default: "100%",
      type: String,
    },
    content: {
      default: "",
      type: String,
    },
  },
  components: { uploadImg ,uploadVideo,uploadPdf},
  data() {
    //这里存放数据
    return {
      isnocaijian: false,
      isEditorBox: true,
      imgArr: [],
      imgNumber: 1,
      num: "",
      fixedNumber: [9, 16],
      boxheight: "",
      allHeight: "",
      isActive: false,
      editorOption: {
        placeholder: "请输入内容...",
        modules: {
          toolbar: {
            container: this.showImg
              ? toolbarOptions
              : toolbarOptions.slice(0, toolbarOptions.length - 1), // 工具栏
            handlers: {
              image: (value, $event) => {
                console.log(value, $event);
                if (value) {
                  document
                    .querySelector(`#quill-uploadimg${this.i} input`)
                    .click();
                } else {
                  alert("获取图片失败");
                  this.quill.format("image", false);
                }
              },
              video: (value, $event) => {
                console.log(value, this);
                if (value) {
                  document
                    .querySelector(`#quill-uploadvideo${this.i} input`)
                    .click();
                } else {
                  alert("获取图片失败");
                  this.quill.format("image", false);
                }
              },
              upload: (value, $event) => {
                console.log(value, $event);
                if (value) {
                  document
                    .querySelector(`#quill-uploadfile${this.i} input`)
                    .click();
                } else {
                  alert("获取图片失败");
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      isShowAll: false,
      isShowSeletImageModal: false,
      contentText: "",
      width100: true,
      quill: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    content() {
      this.contentText = this.content;
    },
    contentText() {
      this.$emit("editorContent", this.contentText);
    },
  },
  //方法集合
  methods: {
    onEditorReady(dom) {
      console.log(dom);
      this.contentText = this.value; // 在ready方法中手动赋值
    },
    footerClick() {
      if (this.isShowAll) {
        this.$refs["myQuillEditor" + this.i].$el.style.height =
          this.allHeight;
        this.$refs["myQuillEditor" + this.i].$el.querySelector(
          ".ql-container"
        ).style.height = this.boxheight;
      } else {
        this.$refs["myQuillEditor" + this.i].$el.querySelector(
          ".ql-container"
        ).style.height = "auto";
        this.$refs["editkuang"].style.height = "auto";
        this.$refs["myQuillEditor" + this.i].$el.style.height = "100%";
      }
      this.isShowAll = !this.isShowAll;
    },
    closeShow() {
      this.$refs["myQuillEditor" + this.i].$el.querySelector(
        ".ql-container"
      ).style.height = this.boxheight;
      this.isShowAll = false;
    },
    saveImg(data) {
      this.imgArr.push(data);
      let path = data.path;
      //var url = "http://bkccshequ.img-cn-beijing.aliyuncs.com/a286fbec-a410-4e20-96ef-34c8848bb2bc.jpeg"
      this.isActive = true;
      console.log("myQuillEditor" + this.i);
      console.log(this.$refs["myQuillEditor" + this.i]);
      let quill = this.$refs["myQuillEditor" + this.i].quill;
      console.log(quill.getSelection());
      // 如果上传成功
      //if (res.res_code === '1') {
      // 获取光标所在位置
      let length = quill.getSelection().index;
      // 插入图片 res.info为服务器返回的图片地址
      quill.insertEmbed(length, "image", path);
      // 调整光标到最后
      quill.setSelection(length + 1);
    },
    delPic() {},
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.nocaijian);
    this.isnocaijian = this.nocaijian;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.contentText = this.content;
    let child = this.$refs["myQuillEditor" + this.i].$refs["editor"];

    this.$refs["myQuillEditor" + this.i].$el.insertBefore(
      this.$refs["edittitle"],
      child
    );
    this.$nextTick(function () {
      if (this.showFooter) {
        //整个编辑框的高度，包含编辑框和工具条
        this.allHeight = this.$refs.editkuang.offsetHeight - 54 + "px";
        this.$refs["myQuillEditor" + this.i].$el.style.height = this.allHeight;
        //内部真正的编辑框的高度
        let height =
          this.$refs.editkuang.offsetHeight -
          this.$refs.edittitle.offsetHeight -
          12 -
          66 -
          54 +
          "px";
        //if(this.padding) height = height - this.padding*2
        this.boxheight = height;
        this.$refs["myQuillEditor" + this.i].$el.querySelector(
          ".ql-container"
        ).style.height = height;
        this.$refs["myQuillEditor" + this.i].$el.querySelector(
          ".ql-container"
        ).style.minHeight = height;
      } else {
        this.$refs["myQuillEditor" + this.i].$el.querySelector(
          ".ql-container"
        ).style.height = this.contentHight + "px";
      }
      let conWidth =
        this.$refs["myQuillEditor" + this.i].$el.querySelector(
          ".ql-container"
        ).offsetWidth;

      try {
        if (JSON.stringify(this.$slots).length == 2) {
          //判断如果没有slot去掉内容框的border
          this.$refs["myQuillEditor" + this.i].$el.querySelector(
            ".ql-container"
          ).style.borderTop = "0px";
        }
      } catch (error) {}
      this.$refs["myQuillEditor" + this.i].$el.querySelector(
        ".ql-container"
      ).style.width = conWidth + "px";
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/* 样式穿透 覆盖富文本样式 */
.edit /deep/ .ql-blank::before {
  font-style: normal;
}
.edit /deep/ em {
  font-style: italic;
}
.edit /deep/ strong {
  font-weight: bolder;
}
.edit{
  overflow: hidden;
}

// .edit{
//   padding:0 !important
// }
input,
input:active,
input:hover,
input:focus {
  border: none !important;
  outline: none;
  box-shadow: none;
  width: 100%;
}
.editbox {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  position: relative;
}
.blank_left {
  position: absolute;
  bottom: -2;
  left: 0;
  height: 3px;
  width: 15px;
  background-color: #fff;
  z-index: 1;
}

.editkuang {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.editkuang /deep/ .ql-editor {
  white-space: normal;
  padding-bottom: 0;
  
}
.footer {
  height: 54px;
  line-height: 54px;
  // width: 100%;
  margin: 0 15px;
  text-align: center;
  border: 1px solid #ccc;
  border-top: none;
  cursor: pointer;
  .icon-gengduo {
    display: inline-block;
    color: #677a9e;
    margin-right: 8px;
    transition: all 0.3s linear;
  }
  .icon-show-all {
    transform: rotate(180deg);
  }
}

</style>
<style>
.ql-snow .ql-formats .ql-upload{
  background: url('../assets/images/epidemicForm/文件夹.png');
  background-size: 24px 24px;
}
</style>

